import React, { useMemo } from 'react'
import { CTable } from '@coreui/react-pro'
import { Prize } from '../../types'
import { Typography } from 'antd'

const columns = [
  {
    key: 'place',
    label: 'Place',
    _props: { scope: 'col' },
  },
  {
    key: 'amount',
    label: 'Amount',
    _props: { scope: 'col' },
  },
]

type Props = {
  prizes: Prize[]
}

export const PrizesTable: React.FC<Props> = ({ prizes }) => {
  const items = prizes.map((item, index) => ({
    id: index,
    place: item.place,
    amount: item.amount,
  }))

  return (
    <div>
      <Typography.Title level={3}>Prizer</Typography.Title>
      <CTable columns={columns} items={items} />
    </div>
  )
}
